module.exports = __webpack_public_path__ + "img/instagram.4c553f24.png";